import React from 'react';
import { CircleXIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const pains = ['Perdés horas redactando demandas y escritos desde cero.', 'Tenés que buscar modelos distintos para cada expediente.', 'Dudás sobre la mejor estrategia frente a la Ley 27.802.', 'Pasás horas buscando jurisprudencia actualizada.', 'Necesitás adaptar contratos y telegramas constantemente.'];
  return <section className="border-y border-white/10 bg-charcoal px-5 py-14 md:px-8 md:py-20" data-id="element-145">
      <div className="mx-auto max-w-3xl" data-id="element-146">
        <FadeIn className="text-center" data-id="element-147">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-accent" data-id="element-148">
            La práctica cotidiana
          </p>
          <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-149">
            Esto seguramente también te pasa
          </h2>
        </FadeIn>

        <div className="mt-8 space-y-3" data-id="element-150">
          {pains.map(pain => <div key={pain} className="flex items-center gap-3 border border-white/10 bg-ink px-4 py-4" data-id="element-151">
              <CircleXIcon size={19} className="shrink-0 text-red-300" aria-hidden="true" data-id="element-152" />
              <p className="text-sm font-medium text-stone-200 md:text-base" data-id="element-153">
                {pain}
              </p>
            </div>)}
        </div>

        <FadeIn className="mt-8 text-center" data-id="element-154">
          <p className="font-display text-xl font-bold text-white md:text-2xl" data-id="element-155">
            No necesitás más teoría.
          </p>
          <p className="mt-1 text-lg font-semibold text-accent md:text-xl" data-id="element-156">
            Necesitás un sistema profesional de trabajo.
          </p>
        </FadeIn>
      </div>
    </section>;
}